// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vs__dropdown-menu li[data-v-27ecd2e5]:hover{background-color:#f8d7da!important;color:#721c24!important;cursor:not-allowed}", ""]);
// Exports
module.exports = exports;
